<template>
	<v-app style="background:#303030">
		<!-- HEADER BAR START-->
		<v-app-bar app clipped-left dense>
			<v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
			<v-col>
				<v-toolbar-title>Page Builder</v-toolbar-title>
			</v-col>
			<v-col class="text-left d-flex">
				<v-tabs :centered="true" :grow="false" v-model="pageTabs" background-color="transparent">
					<v-tab>Page One</v-tab>
					<v-tab>Page Two</v-tab>
					<v-tab>Page Three</v-tab>
				</v-tabs>
			</v-col>
			<v-col class="text-right">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn text v-on:click.prevent="zoomLevel += 1; saveSectionsLocally()" v-on="on">
							<v-icon>mdi-magnify-plus-outline</v-icon>
						</v-btn>
					</template>
					<span>Zoom In</span>
				</v-tooltip>

				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn text v-on:click.prevent="zoomLevel -= 1; saveSectionsLocally();" v-on="on">
							<v-icon>mdi-magnify-minus-outline</v-icon>
						</v-btn>
					</template>
					<span>Zoom Out</span>
				</v-tooltip>

				<!-- DIALOG START -->
				<v-dialog v-model="deleteDialog" scrollable max-width="500">
					<template v-slot:activator="{ on }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn text v-on:click.prevent="deleteDialog = true" v-on="on">
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</template>
							<span>Clear All</span>
						</v-tooltip>
					</template>
					<v-card>
						<v-card-title class="headline">Are you sure you want to start again?</v-card-title>
						<v-card-text>Clearing your screens will remove all your selected screens from your canvas. Refreshing your page will not restore your selection either.</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="darken-3" text @click="deleteDialog = false">Nevermind</v-btn>
							<v-btn color="error" text @click="clearAll(); deleteDialog = false;">
								<v-icon>mdi-delete</v-icon>Proceed
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<!-- DIALOG END -->
				<!-- DIALOG START -->
				<v-dialog v-model="importDialog" scrollable max-width="500">
					<template v-slot:activator="{ on }">
						<v-tooltip bottom v-on="on">
							<template v-slot:activator="{ on }">
								<v-btn text v-on:click="importDialog = true" v-on="on">
									<v-icon>mdi-import</v-icon>
								</v-btn>
							</template>
							<span>Import</span>
						</v-tooltip>
					</template>
					<v-card>
						<v-card-title class="headline">Import your selections?</v-card-title>
						<v-card-text>To import your screens, please copy and paste the code below from the export dialog.</v-card-text>
						<v-card-text>
							<v-alert
								type="warning"
								text
							>Importing will override the current sections on the canvas. This cannot be undone.</v-alert>
						</v-card-text>
						<v-card-text>
							<v-text-field
								rounded
								filled
								single-line
								v-model="importValue"
								:error="importError"
								placeholder="Paste your exported code here"
							/>
							<v-alert v-if="importError" color="red" type="error" text>Improperly formatted code</v-alert>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="darken-1" text @click="importDialog = false">Close</v-btn>
							<v-btn color="error" text @click="importObject()">Import</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<!-- DIALOG END -->
				<!-- DIALOG START -->
				<v-dialog v-model="exportDialog" scrollable max-width="500">
					<template v-slot:activator="{ on }">
						<v-tooltip bottom v-on="on">
							<template v-slot:activator="{ on }">
								<v-btn text v-on:click="exportDialog = true" v-on="on">
									<v-icon>mdi-export-variant</v-icon>
								</v-btn>
							</template>
							<span>Export</span>
						</v-tooltip>
					</template>
					<v-card>
						<v-card-title class="headline">Export your selections?</v-card-title>
						<v-card-text>
							To export your screens, please copy and paste the code below and
							send it through to mail@jordangeizer.com
						</v-card-text>
						<v-sheet color="black">
							<v-card-text style="height: 200px; overflow:auto;">{{ selectedSections }}</v-card-text>
						</v-sheet>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="darken-1" text @click="exportDialog = false">Close</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<!-- DIALOG END -->
			</v-col>
		</v-app-bar>
		<!-- HEADER BAR END -->

		<!-- SIDEBAR START -->
		<v-navigation-drawer v-model="drawer" app clipped width="384px">
			<v-col class="d-flex" cols="12">
				<!-- FILTER SELECTOR START -->
				<v-select
					v-model="selectedCategory"
					:items="categories"
					item-text="label"
					item-value="id"
					filled
					label="Select A Section"
					solo
					hide-details
				></v-select>
				<!-- FILTER SELECTOR END -->
			</v-col>
			<v-list dense>
				<!-- LIBRARY LIST START -->
				<draggable
					class="list-group"
					:list="filteredSections"
					:group="{ name: 'sections', pull: 'clone', put: false }"
					:sort="false"
				>
					<v-list-item v-for="(element, index) in filteredSections" :key="index">
						<v-list-item-content>
							<div class="list-group-item">
								<!-- <img :src="element.url" width="100%"/> -->
								<v-img eager :src="element.url" max-width="337px" contain>
									<template v-slot:placeholder>
										<v-row class="fill-height ma-0 black" align="center" justify="center">
											<v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
										</v-row>
									</template>
								</v-img>
							</div>
						</v-list-item-content>
					</v-list-item>
				</draggable>
				<!-- LIBRRARY LIST END -->
			</v-list>
		</v-navigation-drawer>
		<!-- SIDEBAR END -->

		<v-content>
			<v-container fluid fill-height>
				<!-- <div class="get-started-message headline text-center col-12 fill-height">
            <v-row align="center" class="flex-column align-self-center">
              <v-icon x-large class="mb-5" color="grey">mdi-selection-ellipse-arrow-inside</v-icon>
              <p>Drag a section here to get started</p>
            </v-row>
				</div>-->
				<v-layout
					align-center
					justify-center
					style="font-size:0px; line-height:0px;"
					class="flex-column"
				>
					<v-col class="d-flex" :cols="zoomLevel">
						<!-- PAGE TAB START-->
						<v-tabs-items v-model="pageTabs" style="min-height:300px; width:100%">
							<!-- SELECTED LIST START -->
							<v-tab-item style="min-height:300px; width:100%">
								<draggable
									class="list-group"
									:list="selectedSections[0]"
									group="sections"
									v-bind="dragOptions"
									@start="drag = true"
									@end="drag = true"
									@change="saveSectionsLocally"
									style="min-height:300px; width:100%"
									v-bind:class="{ screenCanvas: !hasSections }"
								>
									<!-- CARD START-->
									<div v-for="(element, index) in selectedSections[0]" :key="element.name">
										<v-hover v-slot:default="{ hover }" class="list-group-item">
											<v-card class="mx-auto" color="grey lighten-4" tile elevation="0">
												<img :src="element.url" width="100%" />
												<v-fade-transition>
													<div
														v-if="hover"
														class="d-flex grey darken-2 darken-2 display-3 white--text v-card--reveal"
													>
														<v-btn color="grey" class="white--text mr-4 cursor-move" center middle outlined fab>
															<v-icon>mdi-menu</v-icon>
														</v-btn>
														<v-btn
															color="grey"
															class="white--text mr-4"
															center
															middle
															v-on:click.prevent="deleteObject(index, 0)"
															outlined
															fab
														>
															<v-icon>mdi-delete</v-icon>
														</v-btn>
													</div>
												</v-fade-transition>
											</v-card>
										</v-hover>
									</div>
									<!-- CARD END -->
								</draggable>
							</v-tab-item>
							<!-- SELECTED LIST END -->
							<!-- SELECTED LIST START -->
							<v-tab-item style="min-height:300px; width:100%">
								<draggable
									class="list-group"
									:list="selectedSections[1]"
									group="sections"
									v-bind="dragOptions"
									@start="drag = true"
									@end="drag = true"
									@change="saveSectionsLocally"
									style="min-height:300px; width:100%"
									v-bind:class="{ screenCanvas: !hasSections }"
								>
									<!-- CARD START-->
									<div v-for="(element, index) in selectedSections[1]" :key="element.name">
										<v-hover v-slot:default="{ hover }" class="list-group-item">
											<v-card class="mx-auto" color="grey lighten-4" tile elevation="0">
												<img :src="element.url" width="100%" />
												<v-fade-transition>
													<div
														v-if="hover"
														class="d-flex grey darken-2 darken-2 display-3 white--text v-card--reveal"
													>
														<v-btn color="grey" class="white--text mr-4 cursor-move" center middle outlined fab>
															<v-icon>mdi-menu</v-icon>
														</v-btn>
														<v-btn
															color="grey"
															class="white--text mr-4"
															center
															middle
															v-on:click.prevent="deleteObject(index, 1)"
															outlined
															fab
														>
															<v-icon>mdi-delete</v-icon>
														</v-btn>
													</div>
												</v-fade-transition>
											</v-card>
										</v-hover>
									</div>
									<!-- CARD END -->
								</draggable>
							</v-tab-item>
							<!-- SELECTED LIST END -->
							<!-- SELECTED LIST START -->
							<v-tab-item style="min-height:300px; width:100%">
								<draggable
									class="list-group"
									:list="selectedSections[2]"
									group="sections"
									v-bind="dragOptions"
									@start="drag = true"
									@end="drag = true"
									@change="saveSectionsLocally"
									style="min-height:300px; width:100%"
									v-bind:class="{ screenCanvas: !hasSections }"
								>
									<!-- CARD START-->
									<div v-for="(element, index) in selectedSections[2]" :key="element.name">
										<v-hover v-slot:default="{ hover }" class="list-group-item">
											<v-card class="mx-auto" color="grey lighten-4" tile elevation="0">
												<img :src="element.url" width="100%" />
												<v-fade-transition>
													<div
														v-if="hover"
														class="d-flex grey darken-2 darken-2 display-3 white--text v-card--reveal"
													>
														<v-btn color="grey" class="white--text mr-4 cursor-move" center middle outlined fab>
															<v-icon>mdi-menu</v-icon>
														</v-btn>
														<v-btn
															color="grey"
															class="white--text mr-4"
															center
															middle
															v-on:click.prevent="deleteObject(index, 2)"
															outlined
															fab
														>
															<v-icon>mdi-delete</v-icon>
														</v-btn>
													</div>
												</v-fade-transition>
											</v-card>
										</v-hover>
									</div>
									<!-- CARD END -->
								</draggable>
							</v-tab-item>
							<!-- SELECTED LIST END -->
						</v-tabs-items>
						<!-- PAGE TABS END -->
					</v-col>
				</v-layout>
			</v-container>
		</v-content>
	</v-app>
</template>

<style scoped>
.screenCanvas {
	border: 2px dashed grey;
	color: grey;
}

.get-started-message {
	position: absolute;
	width: 100%;
	height: 100%;
}

.v-card--reveal {
	align-items: center;
	bottom: 0;
	justify-content: center;
	opacity: 0.8;
	position: absolute;
	width: 100%;
	height: 100%;
}
.sortable-chosen {
	padding: 1rem;
	transition: padding 0.05s ease-in;
}
.list-group-item,
.cursor-move,
button.cursor-move i {
	cursor: move;
}
.list-group-item i {
	cursor: pointer;
}
</style>

<script>
import draggable from "vuedraggable";
import Sections from "../image-map3.json";
import dynamicCategories from "../categories.json";
// import colors from 'vuetify/lib/util/colors'

const sectionLibrary = Sections;

const FILTER_ALL = "All";
const FILTER_NONE = "Select A Category";

export default {
	name: "App",
	// DRAGGABLE START
	display: "Transitions",
	// DRAGGABLE END
	components: {
		draggable
	},
	data: () => ({
		drawer: null,
		pageTabs: null,
		// CATEGORIES
		categories: dynamicCategories,
		selectedCategory: FILTER_NONE,
		deleteDialog: false,
		exportDialog: false,
		importDialog: false,
		importValue: "",
		// SECTIONS
		sections: sectionLibrary.map((section, index) => {
			return {
				categoryID: section.categoryID,
				url: `../assets/bright/` + section.sectionDesktop,
				id: index + 1,
				fixed: false
			};
		}),
		selectedSections: [[], [], []],
		editable: true,
		isDragging: false,
		delayedDragging: true,
		zoomLevel: 6
	}),
	mounted() {
		//  LOAD LOCAL STORAGE
		if (JSON.parse(localStorage.getItem("localSections")).length === 3) {
			try {
				this.selectedSections = JSON.parse(
					localStorage.getItem("localSections")
				);
			} catch (e) {
				localStorage.removeItem("localSections");
			}
		}
		if (JSON.parse(localStorage.getItem("localZoomLevel"))) {
			try {
				this.zoomLevel = JSON.parse(
					localStorage.getItem("localZoomLevel")
				);
			} catch (e) {
				localStorage.removeItem("localZoomLevel");
			}
		}
	},
	computed: {
		filteredSections() {
			if (this.selectedCategory === FILTER_ALL) return this.sections;
			if (this.selectedCategory === FILTER_NONE) return null;
			else
				return this.sections.filter(s => s.categoryID == this.selectedCategory);
		},
		hasSections() {
			// selectedSections variable should start with one blank object
			if (this.selectedSections.length > 1) return true;
			else return false;
		},
		// DRAGGABLE START
		dragOptions() {
			return {
				animation: 200,
				group: "sections",
				disabled: false,
				ghostClass: "ghost"
			};
		},
		// DRAGGABLE END
		importError() {
			try {
				JSON.parse(this.importValue) === 3;
			} catch (e) {
				return true;
			}
			return false;
		}
	},
	methods: {
		deleteObject: function(index, listNo) {
			this.$delete(this.selectedSections[listNo], index);
			// LOCALSTORAGE SAVE ON DELETE
			this.saveSectionsLocally();
		},
		// LOCALSTORAGE SAVE FUNCTION
		saveSectionsLocally() {
			const parsed = JSON.stringify(this.selectedSections);
			localStorage.setItem("localSections", parsed);
			localStorage.setItem("localZoomLevel", this.zoomLevel);
			// console.log("BRIEF BUILDER - Saved to local storage.");
		},
		clearAll: function() {
			localStorage.clear("localSections");
			localStorage.clear("localZoomLevel");
			this.zoomLevel = 6;
			this.selectedSections = [[], [], []];
		},
		importObject() {
			if (this.importError !== true) {
				this.selectedSections = JSON.parse(this.importValue);
				this.importDialog = false;
			}
		}
	}
};
</script>
